<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    preserveAspectRatio="xMidYMid"
    x="0px"
    y="0px"
  >
    <title>Play</title>
    <polygon points="19,14 82,50 19,86" fill="black" />
  </svg>
</template>
<script setup lang="ts"></script>
